export default {
  geolocation: null,
  id: null,
  sessionId: null,
}
